import { IAppState } from '../../../AppModulesWrapper';

import { EServiceId } from '../../types/reducers/publishTerms';
import { IBetPosition } from '../../types/reducers/betPosition';

export const selectTopAuctionBetPosition = (state: IAppState): IBetPosition | null => {
  const {
    betPosition: { positionByService },
  } = state.servicePickerWidgetV2;

  return positionByService[EServiceId.paid] || positionByService[EServiceId.free] || null;
};
